import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from 'lucide-react';
import { Badge } from "@/components/ui/badge";
import { Link } from 'react-router-dom';
import { createPageUrl } from '@/utils';

export default function ArchiveWarningDialog({
  open,
  onClose,
  onConfirm,
  entityType,
  entityName,
  dependents
}) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent data-testid="common-archivewarningdialog-dialog" className="bg-slate-900 border-slate-800 text-slate-100 max-w-2xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-amber-400">
            <AlertTriangle className="w-5 h-5" />
            Archive {entityType}?
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          <p className="text-slate-300">
            You are about to archive <span className="font-semibold text-white">"{entityName}"</span>
          </p>
          
          {dependents && dependents.length > 0 &&
          <div className="p-4 bg-amber-500/10 border border-amber-500/30 rounded-lg space-y-3">
              <p className="text-sm font-semibold text-amber-400">
                This {entityType} has {dependents.length} dependent(s):
              </p>
              <div className="space-y-2 max-h-60 overflow-y-auto">
                {dependents.map((dep, idx) =>
              <Link
                key={idx}
                to={createPageUrl(dep.page)}
                className="block p-2 bg-slate-950/50 rounded border border-slate-700 hover:border-indigo-500 transition-colors">

                    <div className="flex items-center justify-between">
                      <div>
                        <Badge variant="outline" className="text-slate-50 mb-1 px-2.5 py-0.5 text-xs font-semibold rounded-md inline-flex items-center border transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
                          {dep.type}
                        </Badge>
                        <p className="text-sm text-slate-200">{dep.name}</p>
                        {dep.code &&
                    <p className="text-xs text-slate-500 mt-1">{dep.code}</p>
                    }
                      </div>
                      <span className="text-xs text-indigo-400">View →</span>
                    </div>
                  </Link>
              )}
              </div>
              <p className="text-xs text-slate-400 mt-2">
                These dependents will still exist but will show that their parent is archived.
              </p>
            </div>
          }

          {(!dependents || dependents.length === 0) &&
          <p className="text-sm text-slate-400">
              This {entityType} has no dependents.
            </p>
          }
        </div>

        <DialogFooter>
          <Button data-testid="common-cancel-btn" variant="outline" onClick={onClose} className="bg-background text-slate-700 px-4 py-2 text-sm font-medium rounded-md inline-flex items-center justify-center gap-2 whitespace-nowrap transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input shadow-sm hover:bg-accent hover:text-accent-foreground h-9">
            Cancel
          </Button>
          <Button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className="bg-amber-600 hover:bg-amber-700">

            Proceed with Archive
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>);

}